import { FoundationBaseDirective } from '@csspension/base-angular';
import { Directive } from '@angular/core';

@Directive()
export abstract class BaseDirective extends FoundationBaseDirective {}
